var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "board_outline_24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36582",
    x: 3,
    y: 3,
    width: 18,
    height: 14,
    rx: 1,
    stroke: "#AC92ED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4984 5.84664C15.3031 5.65138 14.9865 5.65138 14.7913 5.84664L14.0842 6.55375L15.6719 8.14149L16.379 7.43439C16.5743 7.23912 16.5743 6.92254 16.379 6.72728L15.4984 5.84664ZM9.51596 14.1232C9.63662 14.115 9.75023 14.0634 9.83575 13.9779L15.1579 8.65567L13.5702 7.06793L8.248 12.3901C8.16249 12.4756 8.11086 12.5892 8.1027 12.7099L8.03877 13.6545C8.01831 13.9567 8.26916 14.2075 8.57139 14.1871L9.51596 14.1232Z",
    fill: "#AC92ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36583",
    d: "M6.5 22C5.94772 22 5.5 21.5523 5.5 21L5.5 19L7.5 19L7.5 21C7.5 21.5523 7.05228 22 6.5 22Z",
    fill: "#AC92ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 36584",
    d: "M18 22C17.4477 22 17 21.5523 17 21L17 19L19 19L19 21C19 21.5523 18.5523 22 18 22Z",
    fill: "#AC92ED"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36585",
    x: 7,
    y: 19,
    width: 10,
    height: 1,
    fill: "#AC92ED"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesks);
export default __webpack_public_path__ + "static/media/desks.242b28dabc8abdf81117f2caaea4d353.svg";
export { ForwardRef as ReactComponent };